// House of Wellness homepage - light interactions
(function () {
  // Product filter by room
  var filters = document.querySelectorAll('.filter');
  var products = document.querySelectorAll('.product');
  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = btn.getAttribute('data-f');
      filters.forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      products.forEach(function (p) {
        var show = f === 'all' || p.getAttribute('data-room') === f;
        p.classList.toggle('is-hidden', !show);
      });
    });
  });

  // Life-stage tabs
  var tabs = document.querySelectorAll('.stage-tab');
  var panels = document.querySelectorAll('.stage-panel');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var s = tab.getAttribute('data-stage');
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-stage') === s);
      });
    });
  });

  // FAQ: keep only one open at a time
  var faqs = document.querySelectorAll('.faq-list details');
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();


// Decode You quiz engine - reads window.HOWQUIZ (generated from quiz_data.py)
(function () {
  var D = window.HOWQUIZ;
  var state = { room: null, steps: [], idx: 0, answers: {} };

  var $ = function (id) { return document.getElementById(id); };
  var screens = document.querySelectorAll('.qscreen');
  function show(name) {
    screens.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-screen') === name); });
    window.scrollTo({ top: 0, behavior: 'auto' });
  }
  function roomClass(room) { return room ? room.toLowerCase() : ''; }

  // ---- Flow ----
  function start() {
    state = { room: null, steps: [{ type: 'q', q: D.Q1 }], idx: 0, answers: {} };
    renderStep();
  }
  function buildRoomSteps(room) {
    state.room = room;
    state.steps = state.steps.slice(0, state.idx + 1);
    state.steps.push({ type: 'room', room: room });
    D.QUESTIONS[room].forEach(function (q) { state.steps.push({ type: 'q', q: q, room: room }); });
    state.steps.push({ type: 'result' });
  }
  function renderStep() {
    var step = state.steps[state.idx];
    if (step.type === 'q') renderQuestion(step);
    else if (step.type === 'room') renderRoom(step.room);
    else renderResult();
    updateProgress();
  }
  function updateProgress() {
    var qSteps = state.steps.filter(function (s) { return s.type === 'q'; });
    var done = state.steps.slice(0, state.idx + 1).filter(function (s) { return s.type === 'q'; }).length;
    var p = $('progress');
    var isQ = state.steps[state.idx].type === 'q';
    p.hidden = !isQ;
    if (isQ) {
      var total = state.room ? qSteps.length : qSteps.length + 7;
      $('progress-label').textContent = 'Question ' + done + ' of ' + total;
      $('progress-bar').style.width = Math.round((done / total) * 100) + '%';
    }
  }

  // ---- Question screen ----
  function renderQuestion(step) {
    var q = step.q;
    var room = step.room;
    var wrap = document.querySelector('.qwrap');
    wrap.className = 'wrap qwrap ' + roomClass(room);
    $('q-room').textContent = room ? D.ROOMS[room].title + ' - ' + D.ROOMS[room].quiz_title : '';
    $('q-text').textContent = q.text;
    $('q-hint').textContent = q.type === 'multi' ? 'Choose all that apply' : (q.safety ? 'This helps us make sure a product is the right answer for you.' : '');
    var box = $('q-options'); box.innerHTML = '';
    var picked = state.answers[q.id] || [];
    q.options.forEach(function (o, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'opt' + (q.type === 'multi' ? ' multi' : '') + (picked.indexOf(i) > -1 ? ' is-picked' : '');
      b.textContent = o.t;
      b.addEventListener('click', function () { pick(q, i); });
      box.appendChild(b);
    });
    $('back').style.visibility = state.idx === 0 ? 'hidden' : 'visible';
    $('next').disabled = picked.length === 0;
    $('next').textContent = 'Next';
    show('question');
  }
  function pick(q, i) {
    var cur = state.answers[q.id] || [];
    if (q.type === 'multi') {
      var at = cur.indexOf(i);
      if (at > -1) cur.splice(at, 1); else cur.push(i);
    } else {
      cur = [i];
    }
    state.answers[q.id] = cur;
    var opts = $('q-options').children;
    for (var k = 0; k < opts.length; k++) opts[k].classList.toggle('is-picked', cur.indexOf(k) > -1);
    $('next').disabled = cur.length === 0;
    if (q.type !== 'multi') setTimeout(next, 260);
  }
  function next() {
    var step = state.steps[state.idx];
    if (step.type === 'q') {
      var q = step.q;
      var a = state.answers[q.id];
      if (!a || !a.length) return;
      // Entry routing
      if (q.id === 'Q1' || q.id === 'Q1b') {
        var room = q.options[a[0]].room;
        if (room === 'UNSURE') {
          state.steps = state.steps.slice(0, state.idx + 1);
          state.steps.push({ type: 'q', q: D.Q1B });
        } else {
          buildRoomSteps(room);
        }
      }
      // Safety branch: skip straight to result
      if (q.safety && q.options[a[0]].tag === 'safety') {
        state.steps = state.steps.slice(0, state.idx + 1);
        state.steps.push({ type: 'result', safety: true });
      }
    }
    state.idx++;
    renderStep();
  }
  function back() {
    if (state.idx === 0) return;
    state.idx--;
    if (state.steps[state.idx].type === 'room') state.idx--;
    renderStep();
  }

  // ---- Room intro ----
  function renderRoom(room) {
    var r = D.ROOMS[room];
    var w = document.querySelector('.room-intro');
    w.className = 'wrap qwrap room-intro ' + roomClass(room);
    var chip = $('r-chip'); chip.textContent = r.title + ' - ' + r.line; chip.className = 'room-chip ' + roomClass(room);
    $('r-title').textContent = r.quiz_title;
    $('r-intro').textContent = r.intro;
    $('r-count').textContent = D.QUESTIONS[room].length + ' questions, about a minute.';
    show('room');
  }

  // ---- Scoring ----
  function score(room) {
    var a = 0, b = 0;
    D.QUESTIONS[room].forEach(function (q) {
      var ans = state.answers[q.id] || [];
      ans.forEach(function (i) {
        var o = q.options[i];
        if (o.tag === 'a') a += o.w;
        else if (o.tag === 'b') b += o.w;
        else if (o.tag === 'both') { a += o.w; b += o.w; }
      });
    });
    return { a: a, b: b };
  }
  function decide(room, s) {
    var m = D.RULES.margin, mb = D.RULES.min_both;
    if (room === 'BLISS') { // single product; headline varies
      if (s.b >= s.a + m) return 'B';
      if (s.a >= s.b + m) return 'A';
      return 'BOTH';
    }
    if (s.a >= s.b + m) return 'A';
    if (s.b >= s.a + m) return 'B';
    if (s.a >= mb && s.b >= mb) return 'BOTH';
    return s.a >= s.b ? 'A' : 'B';
  }

  // ---- Result ----
  function renderResult() {
    var step = state.steps[state.idx];
    var room = state.room;
    var r = D.ROOMS[room];
    var grid = document.querySelector('.result-grid');
    grid.className = 'wrap result-grid ' + roomClass(room);
    var chip = $('res-chip'); chip.textContent = r.title + ' - ' + r.line; chip.className = 'room-chip ' + roomClass(room);
    var s = score(room);
    var key = step.safety ? 'SAFETY' : decide(room, s);
    var res = D.RESULTS[room][key];
    $('res-headline').textContent = res.headline;
    $('res-copy').textContent = res.copy;
    $('res-room-link').textContent = 'Explore the ' + r.title + ' room';

    // Signals
    var sig = $('res-signals'); sig.innerHTML = '';
    if (!step.safety) {
      var max = Math.max(s.a, s.b, 1);
      [[r.a_label, s.a], [r.b_label, s.b]].forEach(function (pair) {
        var d = document.createElement('div'); d.className = 'signal';
        d.innerHTML = '<strong>' + pair[0] + '</strong><span>' + pair[1] + ' pts</span><span class="track"><i style="width:' + Math.round(pair[1] / max * 100) + '%"></i></span>';
        sig.appendChild(d);
      });
    }

    // Room right now
    $('res-code').classList.toggle('is-hidden', !!step.safety);
    $('res-room-name').textContent = r.title;
    $('res-room-line').textContent = r.line;

    // Products
    var box = $('res-products'); box.innerHTML = '';
    if (step.safety) {
      box.innerHTML = '<div class="safety-card"><h3>Please check in with a professional first</h3><p>Persistent itching, burning, unusual discharge or odour, sores or pain can have several causes. A gynaecologist can help you find the right answer - a product isn\'t the place to start.</p><a class="btn btn-primary" href="index.html#footer">Contact us</a><a class="btn btn-ghost" href="index.html">Back to the house</a></div>';
    } else {
      var total = 0, mrp = 0, allLive = true;
      res.products.forEach(function (pid) {
        var p = D.PRODUCTS[pid];
        var card = document.createElement('article'); card.className = 'rp ' + roomClass(p.room);
        var img = p.live ? '<div class="rp-img"><img src="assets/' + p.img + '" alt="' + p.name + '"></div>' : '<div class="rp-img soon">' + p.name.split(' ')[0] + '</div>';
        var price = p.live ? '<p class="price"><strong>Rs. ' + p.price.toLocaleString('en-IN') + '</strong><s>Rs. ' + p.mrp.toLocaleString('en-IN') + '</s></p><div class="product-ctas"><a class="btn btn-primary btn-sm" href="#">Add to Cart</a><a class="btn btn-ghost btn-sm" href="#">Buy Now</a></div>'
                            : '<span class="soon-tag">Launching soon</span><div class="product-ctas"><a class="btn btn-ghost btn-sm" href="#">Notify me</a></div>';
        card.innerHTML = img + '<div><h3>' + p.name + '</h3><p class="pack">' + p.pack + '</p><p class="why">' + p.why + '</p>' + price + '</div>';
        box.appendChild(card);
        if (p.live) { total += p.price; mrp += p.mrp; } else allLive = false;
      });
      if (res.products.length > 1 && allLive) {
        var b = document.createElement('div'); b.className = 'bundle';
        b.innerHTML = '<p>Your routine, together<small>Rs. ' + total.toLocaleString('en-IN') + ' for both</small></p><a class="btn btn-light" href="#">Add both to cart</a>';
        box.appendChild(b);
      }
    }
    show('result');
  }

  // ---- Wire up ----
  $('w-headline').textContent = D.WELCOME.headline;
  $('w-sub').textContent = D.WELCOME.sub;
  $('start').textContent = D.WELCOME.cta;
  $('start').addEventListener('click', start);
  $('next').addEventListener('click', next);
  $('back').addEventListener('click', back);
  $('enter-room').addEventListener('click', function () { state.idx++; renderStep(); });
  $('retake').addEventListener('click', function () { show('welcome'); $('progress').hidden = true; });
})();
